
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Component } from 'vue'
import type { KlevuFilterResultOptions } from '@klevu/core'
import { ZaprooKlevuFilterManager } from '~/modules/klevu-search/classes/ZaprooKlevuFilterManager'
import BaseCheckbox from '~/components/atoms/BaseCheckbox.vue'
import { safeComputed } from '~/modules/helpers'
import { capitalizeFirstLetter } from '~/modules/helpers/functions/capitalizeFirstLetter'

export default defineComponent({
  name: 'KlevuFilterOptions',
  components: { BaseCheckbox },
  props: {
    wrapper: {
      type: Object as PropType<Component>,
      default: undefined
    },
    filter: {
      type: Object as PropType<KlevuFilterResultOptions>,
      required: true
    },
    filterManager: {
      type: Object as PropType<ZaprooKlevuFilterManager>,
      required: true
    }
  },
  emits: ['filterChanged'],
  setup (props, { emit }) {
    function onValueChange (option: KlevuFilterResultOptions['options'][number], value:boolean):void {
      const { value: optionValue } = option
      const opt = props.filter.options.find(o => o.value === optionValue)

      opt.selected = value
      emit('filterChanged', props.filter)
    }

    const preparedOptions = safeComputed(() => props.filter.options.map(option => ({
      ...option,
      name: capitalizeFirstLetter(option.name)
    })))
    return {
      preparedOptions,
      onValueChange
    }
  }
})

